module.exports = __webpack_public_path__ + "static/media/edward_ng.728774f0.png";